import { render, staticRenderFns } from "./ModalAddCoin.vue?vue&type=template&id=77e13dec&"
import script from "./ModalAddCoin.vue?vue&type=script&lang=js&"
export * from "./ModalAddCoin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports